import { render } from "./ProfilePoliticianInfo.vue?vue&type=template&id=7a7ac6da"
import script from "./ProfilePoliticianInfo.vue?vue&type=script&lang=js"
export * from "./ProfilePoliticianInfo.vue?vue&type=script&lang=js"

import "./ProfilePoliticianInfo.vue?vue&type=style&index=0&id=7a7ac6da&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__